import React from 'react';
import LoadingGif from '../../images/loading.gif';
//import Spinner from 'react-bootstrap/Spinner'
//import Modal from 'react-bootstrap/Modal'
import '../../css/modal1.css';
//import { Modal, View, Text, ActivityIndicator, Button } from 'react';

const Loading = (props) => {
    return (
        (props.loadingShow)
        ?
        (
            <div style={{position:"fixed",zindex:"2",left: "0",top: "0"
                        ,width: "100%",height: "100%",overflow: "auto"
                        ,backgroundColor: 'rgba(0,0,0,0.1)'}}>
                {/* <Spinner animation="border" role="status"
                    style={{position: "absolute",margin: "auto",top: "0"
                            ,left: "0",bottom: "0",right: "0"
                            ,width: "50px",height: "50px"}}
                > */}
                    <img alt='loading...' src={LoadingGif} 
                        style={{position: "absolute",margin: "auto",top: "0"
                            ,left: "0",bottom: "0",right: "0"
                            ,width: "50px",height: "50px"}}/>
                    <span className="sr-only">Loading...</span>
                {//</Spinner>
                }
            </div>
        )
        :
        <></>
    )
}

export default Loading;